export default "__VITE_ASSET__4bb5b2c5__"